export default __webpack_public_path__ + "static/media/maxcoghlan-tablet.a47ca32c.png";